export const EMPLOYEE_ID_DIGITS_RE = /^\d{5}$/;

/** Strips optional MIPL prefix; returns up to 5 digits for the form field. */
export const parseEmployeeIdDigits = (raw) => {
  const s = (raw ?? "").toString().trim();
  if (!s) return "";
  const withoutPrefix = s.replace(/^MI/i, "");
  return withoutPrefix.replace(/\D/g, "").slice(0, 5);
};

export const formatEmployeeIdForApi = (digits) => {
  const d = (digits ?? "").toString().trim();
  return d ? `MI${d}` : "";
};

/** Strips non-digits, caps at 5 — for controlled input while typing. */
export const sanitizeEmployeeIdInput = (raw) =>
  (raw ?? "").toString().replace(/\D/g, "").slice(0, 5);

/** Pads 1–5 digits to exactly 5 with leading zeros (e.g. "2" → "00002"). */
export const normalizeEmployeeIdDigits = (raw) => {
  const digits = sanitizeEmployeeIdInput(raw);
  return digits ? digits.padStart(5, "0") : "";
};
